import { useState } from 'react'
import { useAccordionButton } from 'react-bootstrap/AccordionButton'
import CopyButton from '../shared/CopyButton'
import { formatAddress } from '../../utils/helpers'
import { useDeployedContractStore } from "../../zustand/deployedContractStore"
import { CustomHeaderProps } from '../../types/props'

export const ContractHeader = ({ eventKey, contractName, contractAddress }: CustomHeaderProps) => {
    const [expanded, setExpanded] = useState(false)
    const [mouseDown, setMouseDown] = useState(false)
    const { removeDeployedContract } = useDeployedContractStore()

    const handleToggle = useAccordionButton(eventKey.toString(), () =>
        setExpanded(!expanded)
    )

    return (
        <div className='deployed-contracts-accordion-header'>
            <div>
                <div className={expanded ? "expanded" : ""} onClick={handleToggle}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-chevron-down" viewBox="0 0 16 16">
                        <path fillRule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"/>
                    </svg>
                </div>

                <p className="deployed-contract-header">
                    {contractName} at {formatAddress(contractAddress)}
                </p>
            </div>

            <div>
                <CopyButton value={contractAddress} />
                <button
                    onClick={() => removeDeployedContract(eventKey)}
                    onMouseDown={() => setMouseDown(true)}
                    onMouseUp={() => setMouseDown(false)}
                    className={mouseDown ? 'btn-active' : ''}
                >
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-x-lg" viewBox="0 0 16 16">
                        <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z"/>
                    </svg>
                </button>
            </div>
        </div>
    )
} 